import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import SlateDialog from 'components/Shared/SlateDialog/SlateDialog';
import { setNewSlateViewType } from 'store/actions/slateViews';
import { history } from 'store/createStore';
import { slateViewsTypes, route } from 'config/constants';
import './style.css';

class CreateViewDialog extends Component {
  handleCreateListView = () => {
    this.props.setNewSlateViewType(slateViewsTypes.LIST);
    this.props.onClose();
    history.push({
      pathname: route.SLATE_VIEW_NEW,
    });
  };

  handleCreateMapView = () => {
    this.props.setNewSlateViewType(slateViewsTypes.MAP);
    this.props.onClose();
    history.push({
      pathname: route.SLATE_VIEW_NEW,
    });
  };

  render() {
    var props = this.props;
    var open = props.open;
    var onClose = props.onClose;
    var t = props.t;

    return (
      <SlateDialog
        open={open}
        onClose={onClose}
        title={t('slateViews:createNewView')}
        maxWidth="xs"
      >
        <div className="create-view-dialog-content">
          <div className="create-view-dialog-options">
            <div
              className="create-view-option"
              onClick={this.handleCreateListView}
              role="button"
              tabIndex={0}
              onKeyPress={this.handleCreateListView}
            >
              <div className="create-view-option-icon create-view-option-icon--list">
                <i className="material-symbols-outlined">list</i>
              </div>
              <div className="create-view-option-title">
                {t('slateViews:listView')}
              </div>
              <div className="create-view-option-description">
                {t('slateViews:listViewDescription')}
              </div>
            </div>

            <div
              className="create-view-option"
              onClick={this.handleCreateMapView}
              role="button"
              tabIndex={0}
              onKeyPress={this.handleCreateMapView}
            >
              <div className="create-view-option-icon create-view-option-icon--map">
                <i className="material-symbols-outlined">location_on</i>
              </div>
              <div className="create-view-option-title">
                {t('slateViews:mapView')}
              </div>
              <div className="create-view-option-description">
                {t('slateViews:mapViewDescription')}
              </div>
            </div>
          </div>
        </div>
      </SlateDialog>
    );
  }
}

CreateViewDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  setNewSlateViewType: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(
  connect(null, { setNewSlateViewType })(CreateViewDialog)
);
